module.exports = __webpack_public_path__ + "static/swidro-e22886bc5e53955d538281126de812e7.png";